/* eslint-env browser, es6 */
import m from "mithril";

interface ButtonViewAttrs {
  hookOnClick: () => void;
  message: string;
  disabled?: boolean;
}

export class ButtonView implements m.Component<ButtonViewAttrs> {
  private hookOnClick: () => void;
  private message: string;

  constructor(vnode: m.Vnode<ButtonViewAttrs>) {
    this.hookOnClick = vnode.attrs.hookOnClick;
    this.message = vnode.attrs.message;
  }

  view(vnode: m.Vnode<ButtonViewAttrs>): m.Children {
    return m(
      "button",
      {
        disabled: vnode.attrs.disabled ?? false,
        onclick: () => this.hookOnClick(),
      },
      this.message
    );
  }
}
